module.exports = __webpack_public_path__ + "img/register.bb9e76b5.svg";